import { PageView } from './PageView'
import {PrivacyPolicyController} from "../../Controllers/PageControllers/PrivacyPolicyController";
import {PrivacyPolicyComponent} from "../design/PrivacyPolicyComponent";
import {controllers} from "../../Controllers/Controller";

class PrivacyPolicyPage extends PageView {
    componentDidMount(){
        super.componentDidMount()
        controllers().menu.setIsBlured(true);
        controllers().menu.setIsBluredLock(true);
    }
    componentWillUnmount() {
        controllers().menu.setIsBluredLock(false);
    }
    get controller():PrivacyPolicyController{
        return this.props.controller
    }

    render(){
        return <div className="home page mt-100">
            <PrivacyPolicyComponent />
        </div>
    }
}

export { PrivacyPolicyPage }
